module.exports = __webpack_public_path__ + "img/image4.37459736.png";